
import React, { useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'

import useTranslation from '@/Hooks/UseTranslation'
import { useProgrammation } from '@/Hooks/UseProgrammation'

import { deleteCost, updateCost } from '@/Services/ProgrammationManagerService'

import InputText from '../../components/InputText'

import Spinner from '@/Components/SvgImages/Spinner/Spinner'
import TrashIcon from '@/Components/SvgImages/TrashIcon'

import './CostItem.scss'
import { deleteCostAction, updateCostAction } from '@/Redux/Actions/ProgrammationManagerActions'

const CostItem = ({ resource }: any) => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { itemOpened, setEditingItem, patchItemOpened } = useProgrammation()

  const [ description, setDescription ] = useState(resource.description)
  const [ unit, setUnit ] = useState(resource.unit)
  const [ crewNumber, setCrewNumber ] = useState(resource.crewNumber)
  const [ quantity, setQuantity ] = useState(resource.quantity)
  const [ unitPrice, setUnitPrice ] = useState(resource.unitPrice)
  const [ updating, setUpdating ] = useState(false)
  const [ deleting, setDeleting ] = useState(false)

  const costTypes: any = {
    'labor': t('COSTS_CREATOR:TypeLabor'),
    'material': t('COSTS_CREATOR:TypeMaterial'),
    'tool': t('COSTS_CREATOR:TypeTool'),
  }

  const partial = useMemo(() => {

    if (resource.type === 'labor') {

      return (crewNumber * quantity * unitPrice).toFixed(2)
    }

    if (resource.type === 'material' || resource.type === 'tool') {

      return (quantity * unitPrice).toFixed(2)
    }

    return '0.00'
  }, [ crewNumber, quantity, unitPrice ])

  const handleChangeField = async (field: string, value: any) => {

    switch(field) {
      case 'description':
        setDescription(value)
        break
      case 'unit':
        setUnit(value)
        break
      case 'quantity':
        setQuantity(value)
        break
      case 'unitPrice':
        setUnitPrice(value)
        break
      case 'crewNumber':
        setCrewNumber(value)
        break
      default:
        break
    }

    setEditingItem(true)
    setUpdating(true)

    const cost = {
      ...resource,
      description,
      unit,
      crewNumber,
      quantity,
      unitPrice,
    }

    cost[field] = value

    const [ error, data ] = await updateCost(cost)

    setUpdating(false)
    setEditingItem(false)

    if (error) {
      return console.log(error)
    }

    patchItemOpened({
      resources: itemOpened.resources.map((res: any) => {

        if (res._id === resource._id) {

          res[field] = value
        }

        return res
      })
    })

    await dispatch(updateCostAction(itemOpened._id, resource))
  }

  const handleDelete = async () => {

    setEditingItem(true)
    setDeleting(true)

    const [ error, data ] = await deleteCost(resource._id)

    setDeleting(false)
    setEditingItem(false)

    if (error) {
      return console.log(error)
    }

    patchItemOpened({
      resources: itemOpened.resources.filter((res: any) => res._id !== resource._id)
    })

    await dispatch(deleteCostAction(itemOpened._id, resource._id))
  }

  return (
    <tr key={resource} className='cost-item'>
      <td>
        <span>
          {costTypes[resource.type]}
        </span>
      </td>
      <td>
        <InputText
          value={description}
          onChange={(val: string) => handleChangeField('description', val)}
          delay={1000}
        />
      </td>
      <td>
        <InputText
          value={unit}
          onChange={(val: string) => handleChangeField('unit', val)}
          delay={1000}
          style={{ textAlign: 'right' }}
        />
      </td>
      <td>
        {resource.type === 'labor' && (
          <InputText
            value={crewNumber}
            type='number'
            min="1"
            onChange={(val: string) => handleChangeField('crewNumber', val)}
            delay={1000}
            style={{ textAlign: 'right' }}
          />
        )}
      </td>
      <td>
        <InputText
          value={quantity}
          type='number'
          min="0"
          onChange={(val: string) => handleChangeField('quantity', val)}
          delay={1000}
            style={{ textAlign: 'right' }}
        />
      </td>
      <td>
        <InputText
          value={unitPrice}
          type='number'
          min="0"
          onChange={(val: string) => handleChangeField('unitPrice', val)}
          delay={1000}
            style={{ textAlign: 'right' }}
        />
      </td>
      <td style={{ textAlign: 'right' }}>
        <span>
          {partial}
        </span>
      </td>
      <td style={{ textAlign: 'right' }}>
        <button className='btn btn-danger'
          onClick={() => handleDelete()}
        >
          {deleting && (
            <>
              <Spinner
                height={20}
                width={20}
                fill="#e21c1c"
              />
            </>
          )}
          {!deleting && (
            <>
              <TrashIcon
                height={20}
                width={20}
                color="#e21c1c"
              />
            </>
          )}
        </button>
      </td>
    </tr>
  )
}

export default CostItem
